import { computed } from 'mobx';

export default class AggregationModel {
  id;
  store;

  constructor(store, aggregation) {
    this.store = store;
    this.id = +aggregation.id;
    this.source_series_id = aggregation.source_series_id;
    this.out_series_id = aggregation.out_series_id;
    this.interval_id= aggregation.interval_id;
    this.use_suspicious = aggregation.use_suspicious;
    this.starting_time = aggregation.starting_time;
    this.enabled = aggregation.enabled;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      source_series_id: this.source_series_id,
      out_series_id: this.out_series_id,
      interval_id: this.interval_id,
      use_suspicious: this.use_suspicious,
      starting_time: this.starting_time,
      enabled: this.enabled,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.source_series_id = json.source_series_id;
    this.out_series_id = json.out_series_id;
    this.interval_id = json.interval_id;
    this.use_suspicious = json.use_suspicious;
    this.starting_time = json.starting_time;
    this.enabled = json.enabled;
  }
}



// WEBPACK FOOTER //
// ./src/models/AggregationModel.js